<template>
  <div class="h-full w-full flex">
    <div class="flex-1 h-full flex items-center">
      <div class="flex-1 flex overflow-y-auto h-full justify-center">
        <div class="flex flex-col m-auto py-4">
          <slot />
        </div>
      </div>
    </div>
    <div class="w-4 hidden lg:block" />
    <LoadingImage
      class="flex-1 hidden lg:block top-1/2 transform -translate-y-1/2 w-full h-5/6 object-left rounded-l-lg grayscale hover:grayscale-0 shadow-xl transition-all duration-1000 ease-in-out"
      :high-res-img-src="highResImgSrc"
      :low-res-img-src="lowResImgSrc"
      mode="square-cover"
    />
  </div>
</template>

<script setup lang="ts">
import LoadingImage from '@/components/images/LoadingImage.vue'
defineProps<{
  lowResImgSrc?: string
  highResImgSrc: string
}>()
</script>
